import styled from '@emotion/styled'

export const AttachmentsWrapper = styled.div`
  width: 100%;
  max-width: 350px;
`
